<template>
    <template v-if="props.type !== null">
        <div class=" flex justify-content-end" v-if="props.type !== 'table' && props.type !== 'counter'">
            <Button icon="pi pi-table" :class="{'p-button-rounded p-button-success raised mr-2': true, 'p-button-outlined': !useTable}" @click="onSwitchTableMode"/>
            <Button v-if="props.type === 'bar'" icon="pi pi-chart-bar" :class="{'p-button-rounded p-button-success raised mr-2': true, 'p-button-outlined': useTable}" @click="onSwitchTableMode"/>
            <Button v-if="props.type === 'pie'" icon="pi pi-chart-pie" :class="{'p-button-rounded p-button-success raised mr-2': true, 'p-button-outlined': useTable}" @click="onSwitchTableMode"/>
            <Button v-if="props.type === 'line'" icon="pi pi-chart-line" :class="{'p-button-rounded p-button-success raised mr-2': true, 'p-button-outlined': useTable}" @click="onSwitchTableMode"/>
        </div>

        <div v-if="!useTable && props.type !== 'table' && props.type !== 'counter'" class="flex flex-column justify-content-center align-items-center">
            <div class="flex flex-column justify-content-center align-items-center">
                <h4>{{graphTitle}}</h4>
            </div>

            <Chart :type="props.type" :data="chartData" :options="chartOptions" class="w-full md:w-30rem" />

            <!-- <MetricSeriesGraphTable :type="props.type" :metricData="metricData" :selectedSeriesId="selectedSeriesId"/> -->
        </div>
        <div v-else-if="props.type === 'counter'">
            <!--
            <p>
                users: {{users}}
            </p>-->

            <div>

                <div class="flex flex-column justify-content-center align-items-center">
                    <h4>{{graphTitle}}</h4>
                </div>

                <div class="flex flex-column justify-content-center align-items-center ">
                    <h1 class="counter">{{users.length}}</h1>
                </div>
            </div>

        </div>
        <div v-else>
            <DataTable :value="tableData.rows" class="w-full md:w-30rem mt-3">
                <Column v-for="col of tableData.headers" :key="col.field" :field="col.field" :header="col.header"></Column>
            </DataTable>
        </div>
    </template>
</template>

<script setup>

import { defineProps, onMounted, ref, watch } from 'vue';
// import MetricSeriesGraphTable from '@/components/metrics/components/MetricSeriesGraphTable.vue';

const props = defineProps({
    metricData: {
        type: Object,
        required: true,
    },
    selectedSeriesId: {
        type: Number,
        required: false,
    },
    type: {
        type: [String],
        required: true,
        default: ''
    },
    datasets: {
        type: Object,
        required: true,
        default: () => { return {
            rows: [],
            headers: [],
        }}
    },
    tableData: {
        type: Object,
        required: true,
        default: () => { return {
            labels: [],
            dataset: [],
        }}
    },
    graphTitle: {
        type: String
    },
    users: {
        type: Array,
        required: false,
    },
})

const useTable = ref(false);
const chartData = ref({});
const chartOptions = ref({});

onMounted(() => {
    chartData.value = setChartDataset(props.datasets);
    chartOptions.value = setChartOptions();
})

watch(props, (newValues) => {

    chartData.value = setChartDataset(newValues.datasets);
    chartOptions.value = setChartOptions();
});

function onSwitchTableMode() {
    useTable.value = !useTable.value
}

/**
 * The format bust be the following:
 *
 * labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
 *         datasets: [
 *             {
 *                 label: 'First Dataset',
 *                 data: [65, 59, 80, 81, 56, 55, 40],
 *                 fill: false,
 *                 borderColor: documentStyle.getPropertyValue('--cyan-500'),
 *                 tension: 0.4
 *             },
 *             {
 *                 label: 'Second Dataset',
 *                 data: [28, 48, 40, 19, 86, 27, 90],
 *                 fill: false,
 *                 borderColor: documentStyle.getPropertyValue('--gray-500'),
 *                 tension: 0.4
 *             }
 *         ]
 *
 */
function setChartDataset(datasets) {
    let output = {
        labels: [],
        datasets: [],
    };

    console.log('setChartDataset', datasets)

    if (datasets.dataset) {
        datasets.dataset.forEach((item, index) => {


            let label = datasets.seriesLabel.get(index)
            if (typeof label === 'undefined') {
                // merged graph
                label = index
            }

            if (typeof label === 'undefined') {
                label = 'N.A'
            }

            //console.log('label', label)

            /*
            props.type === 'pie'
             */

            let colours = null;

            if (props.type === 'pie') {
                colours = []
                item.forEach(() => {
                    colours.push(getRandomColor())
                })
            } else {
                colours = getRandomColor()
            }

            let borderColor = '#FFFFFF'
            if (props.type!=='pie') {
                borderColor = '#000000'
            }

            const datum = {
                //label: datasets.seriesLabel[index] + ' - ' + index,
                label: label,
                data: item,
                fill: false,
                backgroundColor: colours,
                borderColor: borderColor,
                hoverBackgroundColor: getRandomColor(),
                tension: 0.4
            }
            output.datasets.push(datum)
        })
    }

    output.labels = datasets.labels

    //console.log('output', output)

    return output
}

function getRandomColor() {
    const letters = '0123456789ABCDEF'.split('');
    let color = '#';
    for (let i = 0; i < 6; i++ ) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

function setChartOptions() {

    if (props.type === 'pie') {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');

        return {
            plugins: {
                legend: {
                    labels: {
                        cutout: '60%',
                        color: textColor
                    }
                }
            },scales: null
        };
    } else {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        return {
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };
    }
}

</script>

<style scoped lang="scss">
.counter {
    font-size: 50px;
}
</style>